export const REASON_FOR_STOP = [
  {
    label: 'Violation of Law other than Traffic',
    value: 'VIOLATION_OF_LAW_OTHER_THAN_TRAFFIC',
  },
  {
    label: 'Pre-Existing Knowledge (IE. Warrant. Etc.)',
    value: 'PRE_EXISTING_KNOWLEDGE',
  },
  {
    label: 'Moving Traffic Violation',
    value: 'MOVING_TRAFFIC_VIOLATION',
  },
  {
    label: 'Vehicle Traffic Violation (Equip Etc.)',
    value: 'VEHICLE_TRAFFIC_VIOLATION',
  },
] as const;
